/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CANCEL: 'Ακύρωση',
    CLOSE: 'Κλείστε το',
    CONFIRM: 'Επιβεβαίωση',
    CONFIRM_AND_NEXT: 'Επιβεβαίωση και επόμενο',
    CONFIRM_AND_SAVE: 'Επιβεβαιώστε και αποθηκεύστε',
    CREATE: 'Δημιουργία',
    DELETE: 'Διαγραφή',
    EDIT: 'Επεξεργασία',
    NEW_POST: 'Νέα δημοσίευση',
    OK: 'OK',
    REJECTED: 'Απορρίφθηκε',
    REPLY: 'Απάντηση',
    SAVE: 'Αποθήκευση',
    SEND: 'Στείλτε',
    SKIP_CROP: 'Αγνοήστε την περικοπή',
    UPDATE: 'Ενημέρωση',
    UPGRADE: 'Εγγραφή στο κλαμπ'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'η αντιγραφή στο πρόχειρο αποτυγχάνει!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Υπήρξε ένα σφάλμα στην κοινοποίηση της ανάρτησης στο Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Υπήρξε ένα σφάλμα στην κοινοποίηση της ανάρτησης στο Instagram. Θέλετε να προχωρήσετε με τη δημοσίευση;',
    LINK_ALREADY_EXISTS: 'Ο σύνδεσμος υπάρχει ήδη',
    LINK_VALIDATION_FAILED: 'Δεν ήταν δυνατή η επαλήθευση του συνδέσμου',
    MANDATORY_FIELD: 'Υποχρεωτικό πεδίο',
    MAXIMUM_CHARACTERS: 'Μέγιστο πλήθος χαρακτήρων',
    MAXIMUM_FILE_SIZE: 'Το μέγιστο επιτρεπόμενο μέγεθος είναι 100MB!',
    MINIMUM_DIMENSIONS:
      'Το αρχείο που μεταφορτώθηκε πρέπει να έχει ελάχιστες διαστάσεις 480×960',
    PAGE_NOT_APPROVED:
      '❌ Δυστυχώς, δεν ήταν δυνατή η έγκριση της σελίδας σου αυτή τη φορά. Αλλά μην ανησυχείς! ✨\n Μπορείς να επεξεργαστείς το προφίλ σου και να διορθώσεις τα υποδεικνυόμενα πεδία για να το υποβάλεις ξανά προς έγκριση.',
    REACTION_LIKE: 'Εμφανίστηκε σφάλμα, παρακαλούμε προσπαθήστε ξανά αργότερα!',
    UNSUPPORTED_FORMAT: 'Η μορφή δεν υποστηρίζεται!',
    VIDEO_CROP: 'Το κόψιμο του βίντεο απέτυχε!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Αποδέχομαι τους όρους και τις προϋποθέσεις',
    ADDITIONAL_INFORMATION: 'Additional information',
    ADDRESS: 'Address',
    APPROVED: 'δημοσιευμένο',
    ASSETS: 'Εικόνες ή βίντεο (μέγιστο μέγεθος 100MB)',
    ASSOCIATE_PRODUCT: 'Συνεργαζόμενο προϊόν prozis',
    ASSOCIATED_PRODUCTS: 'Συναφή προϊόντα prozis',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Λεζάντα',
    CHART_BY: 'Γραφικό από',
    COMMENTS: 'Σχόλια',
    COMMISSION: 'προμήθεια',
    COMMISSIONS: 'προμήθειες',
    COMMISSIONS_LAST_30_DAYS: 'τις τελευταίες 30 ημέρες',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Full address without house number',
    CONTINUE_WITH_INSTAGRAM: 'Συνεχίστε με το Instagram',
    COUNTRY: 'Address with country only',
    CREATE_PROFILE: 'Δημιουργία προφίλ',
    CROPPING_ASSET: 'Κοπή {asset} {ratio}',
    DELETE_POST: 'Διαγραφή ανάρτησης;',
    DELETE_POST_ARE_YOU_SURE:
      'Είστε σίγουρος ότι θέλετε να διαγράψετε την ανάρτηση;',
    DESCRIPTION: 'Βιογραφία',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Λήψη',
    DRAFT_PROFILE: 'Πρόχειρο',
    EDIT_PROFILE: 'Επεξεργασία προφίλ',
    ENGAGEMENT: 'Αλληλεπίδραση',
    ERROR: 'Σφάλμα',
    FEED: 'τροφοδοσία',
    FOLLOWERS: 'Ακολουθητές',
    FRIDAY: 'Friday',
    GALLERY: 'Γκαλερί',
    HIDDEN: 'Does not show address',
    IMAGE: 'εικόνα',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Λογαριασμός Instagram',
    LATEST_FIRST: 'Τελευταία πρώτη',
    LEAST_PROFITABLE: 'Λιγότερο κερδοφόρα πρώτα',
    LIKES: 'Όπως',
    LIKES_DELETED: 'Αφαιρούνται τα likes',
    LINK: 'Σύνδεσμος ',
    LIVE: 'Άμεση',
    LIVES: 'Άμεση',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Διεύθυνση με μόνο πόλη και χώρα',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Πλήρης διεύθυνση',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Πλήρης διεύθυνση χωρίς αριθμό πόρτας',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Διεύθυνση μόνο με χώρα',
    MONDAY: 'Monday',
    MORE: '... Δείτε περισσότερα',
    MOST_PROFITABLE: 'Πιο κερδοφόρα πρώτα',
    NAME: 'Όνομα',
    NEW_FOLLOWERS: 'Νέοι οπαδοί',
    NEW_POST: 'Νέα δημοσίευση',
    NO_PRODUCTS_FOUND: 'Δεν βρέθηκε κανένα προϊόν.',
    NUMBER_OF_FILES: '{file} του {files}',
    OLDEST_FIRST: 'Ο παλαιότερος πρώτος',
    ORIGINAL: 'Αρχικό',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Φωτογραφίες σελίδας',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'σε εκκρεμότητα',
    POST: 'Δημοσίευση',
    POST_COMMENTS: 'Σχόλια σχετικά με τη δημοσίευση',
    POST_PRODUCTS: 'Προϊόντα δημοσίευσης',
    POST_VIEWS: 'Προβολές δημοσιεύσεων',
    POSTING_ON_INSTAGRAM: 'Δημοσίευση στο Instagram',
    POSTS: 'Δημοσιεύσεις',
    PRODUCTS_HASHTAGS: 'Ετικέτες προϊόντων',
    PRODUCTS_LINKS: 'Σύνδεσμοι προϊόντων',
    PROFESSIONAL_PAGE: 'Επαγγελματική σελίδα',
    PROFILE: 'Προφίλ',
    PROFILE_PHOTO: 'Φωτογραφία προφίλ',
    PROFILE_STATUS: 'Κατάσταση προφίλ',
    PROFILE_VIEWS: 'Προβολές προφίλ',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Κοινότητα Prozis',
    QUESTION: 'Ερώτηση',
    QUESTION_REPLY: 'Απαντήστε στην ερώτηση',
    QUESTIONS: 'Ερωτήσεις',
    REELS: 'μπομπίνες',
    REJECTED: 'αδημοσίευτο',
    REJECTED_PROFILE: 'Απορρίφθηκε',
    REJECTION_REASON: 'Λόγος απόρριψης',
    REPLY: 'Απάντηση',
    REQUIRED_FIELDS: 'Υποχρεωτικά πεδία',
    RESET: 'Σαφής',
    SATURDAY: 'Saturday',
    SEARCH: 'Αναζήτηση',
    SEARCH_AT_LEAST:
      'Η λέξη που αναζητάτε πρέπει να έχει μήκος τουλάχιστον 3 χαρακτήρες!',
    SEE_LESS: 'Hide',
    SEE_MORE: 'Δείτε περισσότερα',
    SEE_ORIGINAL: 'Δείτε το πρωτότυπο',
    SEE_TRANSLATION: 'Δείτε τη μετάφραση',
    SHARE_ON_INSTAGRAM: 'Μοιραστείτε στο Instagram',
    SHARE_PROFILE: 'Μοιραστείτε το προφίλ',
    SOCIAL_NETWORK: 'Κοινωνική δικτύωση',
    SOCIAL_NETWORK_COMMISSIONS: 'Επιτροπές κοινωνικών δικτύων',
    SOCIAL_NETWORK_PAGE: 'Κοινωνική σελίδα',
    SOUND: 'Ήχος',
    SPECIALTIES: 'Ειδικότητες',
    STATISTICS_POST: 'Στατιστικά στοιχεία δημοσίευσης',
    STATISTICS_PROFILE: 'Στατιστικά στοιχεία προφίλ',
    STATS_POST_TOTAL: 'Σύνολο προμηθειών δημοσίευσης',
    STATS_POST_TOTAL_COMMENTS: 'Σχόλια/ερωτήσεις σχετικά με τη δημοσίευση',
    STATS_POST_TOTAL_LIKES: 'Αρέσει στη δημοσίευση',
    STATS_POST_TOTAL_PRODUCTS: 'Προϊόντα που σχετίζονται με τη δημοσίευση',
    STATS_POST_TOTAL_QUESTIONS: 'Ερωτήσεις που απαντώνται στη δημοσίευση',
    STATS_POST_TOTAL_VALUE: 'Αξία για δημοσίευση',
    STATS_PROFILE_TOTAL: 'Συνολικές προμήθειες για δημοσιεύσεις',
    STATS_PROFILE_TOTAL_COMMENTS:
      'Σχόλια/ερωτήσεις σχετικά με τις δημοσιεύσεις',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Νέοι οπαδοί που αποκτήθηκαν',
    STATS_PROFILE_TOTAL_LIKES: 'Αρέσει στις δημοσιεύσεις',
    STATS_PROFILE_TOTAL_POSTS: 'Αξία που προκύπτει από δημοσιεύσεις',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Συναφή προϊόντα από δημοσιεύσεις',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Απαντημένες ερωτήσεις για δημοσιεύσεις',
    STORY: 'ιστορία',
    SUCCESS: 'Επιτυχία',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Όροι και προϋποθέσεις',
    THURSDAY: 'Thursday',
    TITLE: 'Τίτλος',
    TOTAL_VIEWS: 'Συνολικές προβολές',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Μη ακόλουθοι',
    UNREAD: 'Για να διαβάσετε',
    UPDATE_POST: 'Δημοσίευση ενημέρωσης',
    UPDATED: 'Ενημερώθηκε σε {date}',
    UPLOAD: 'Ανέβασμα αρχείου',
    UPLOADING_FILES: 'Αποστολή αρχείου(ων)',
    USER_NAME: 'Όνομα χρήστη',
    VIDEO: 'βίντεο',
    VIEW_ALL_COMMENTS: 'Βλέπε σχόλια {total} ',
    VIEW_MORE: 'Δείτε περισσότερα',
    VIEWS: 'Οπτικοποιήσεις',
    VISIBILITY_LEVEL: 'Visibility level',
    WAITING_APPROVAL: 'Εν αναμονή έγκρισης',
    WARNING: 'Προειδοποίηση',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Το προφίλ σας'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Δεν υπάρχουν ακόμη ερωτήσεις.',
    TERMS_AND_CONDITIONS:
      'Με την αλληλεπίδρασή του με το "Κοινωνικό Δίκτυο" της Prozis (ενδεικτικά και όχι εξαντλητικά, κάνοντας σχόλια ή/και κοινοποιώντας περιεχόμενο και αντιδράσεις άμεσα), ο χρήστης δηλώνει ότι έχει διαβάσει, κατανοήσει και αποδεχθεί τους ακόλουθους Όρους και Προϋποθέσεις (ΌΠ).\n\nΗ Prozis διατηρεί το δικαίωμα να επικαιροποιεί τους Όρους και Προϋποθέσεις ανά πάσα στιγμή χωρίς προηγούμενη ειδοποίηση. Η Prozis δικαιούται να ασκήσει όλα τα ένδικα και εύλογα μέσα που έχει στη διάθεσή της.\n\nΜε την πρόσβαση στο "Κοινωνικό Δίκτυο", ο Χρήστης δηλώνει ότι είναι τουλάχιστον 18 ετών και αναλαμβάνει κάθε ευθύνη για τις δημοσιεύσεις, τα σχόλια, τις εικόνες και τα βίντεο που αναρτά ("Περιεχόμενο") στο ίδιο το "Κοινωνικό Δίκτυο".\n\nΤο Περιεχόμενο πρέπει να ανήκει στον Χρήστη, ο οποίος δηλώνει ότι είναι ο δημιουργός και ο ιδιοκτήτης κάθε πνευματικής ιδιοκτησίας. Το Περιεχόμενο δεν πρέπει να αντιπροσωπεύει κάποια συγκεκριμένη κατάσταση, κτίριο ή αντικείμενο ή/και να προστατεύεται από πνευματικά δικαιώματα, εμπορικά σήματα ή, γενικά, εμπορικά σήματα και λογότυπα άλλων εταιρειών, εκτός εάν ο Χρήστης έχει λάβει την απαραίτητη σχετική συγκατάθεση για τη χρήση του.\n\nΤο Περιεχόμενο δεν πρέπει να περιλαμβάνει οποιοδήποτε άλλο πρόσωπο εκτός από τον Χρήστη, εκτός εάν η συγκατάθεση έχει δοθεί από το ίδιο πρόσωπο εγγράφως και η απόκτηση της οποίας αποτελεί ευθύνη του Χρήστη. Ο Χρήστης υποχρεούται να αποζημιώσει και να απαλλάξει την Prozis σε περίπτωση ζημίας που προκαλείται από τη χρήση τέτοιων εικόνων ή/και βίντεο.\n\nΜετά την κοινοποίηση, το Περιεχόμενο αποτελεί αποκλειστική ιδιοκτησία της Prozis, η οποία έχει το δικαίωμα να δημοσιεύει ή/και να διαδίδει ή/και να χρησιμοποιεί ή/και να αναπαράγει ή/και να κοινοποιεί ή/και να τροποποιεί, με οποιοδήποτε τεχνικό μέσο και με οποιονδήποτε τρόπο, το προαναφερθέν Περιεχόμενο, χωρίς αποκλεισμούς, χωρίς χρονικούς περιορισμούς και χωρίς το δικαίωμα οποιασδήποτε αποζημίωσης ή/και αποζημίωσης για τα εμπλεκόμενα ή/και ενδιαφερόμενα πρόσωπα.\n\nΜετά την ενδεχόμενη ανάρτηση περιεχομένου, η Prozis διατηρεί το δικαίωμα να αφήσει ορατό μόνο το υλικό που, κατά τη δική της αδιαμφισβήτητη κρίση, δεν είναι επιβλαβές για την εικόνα των άλλων, καθώς και προσβλητικό για τα τρέχοντα ήθη, ή με άλλο τρόπο επιβλαβές για τα δικαιώματα των άλλων, μεροληπτικό, δυσφημιστικό, άσεμνο, χυδαίο, συκοφαντικό, ρατσιστικό, ή που αποτελεί μορφή διαφήμισης για οποιαδήποτε εμπορική δραστηριότητα που δεν είναι σύμφυτη με το προτεινόμενο θέμα ή σε κάθε περίπτωση που αποσκοπεί στην προώθηση οποιασδήποτε μάρκας, προϊόντος, υπηρεσίας εκτός αυτής του "Κοινωνικού Δικτύου", με περιεχόμενο που δεν είναι πρωτότυπο του Χρήστη, δηλαδή αντιγραμμένο από άλλες πηγές, με περιεχόμενο που παραβιάζει το πορτογαλικό νομικό σύστημα, που αντιβαίνει στη δημόσια ευπρέπεια, στους κανονισμούς περί προστασίας της ιδιωτικής ζωής και, γενικά, στην ισχύουσα νομοθεσία.\n\nΗ Prozis διατηρεί επίσης το δικαίωμα να διαγράψει, πριν ή μετά τη δημοσίευση, κάθε σχόλιο που, κατά την αποκλειστική της κρίση, μπορεί να είναι προσβλητικό, ακατάλληλο ή/και ασυμβίβαστο με το πνεύμα του "Κοινωνικού Δικτύου".\n\nΗ Prozis διατηρεί επίσης το δικαίωμα, ανά πάσα στιγμή, να αφαιρεί σχόλια ή/και περιεχόμενο που δημοσιεύονται στο "Κοινωνικό Δίκτυο" της, ανεξάρτητα ή κατόπιν αιτήματος τρίτων, καθώς και Δικαστικών Αρχών, σε περίπτωση αμφισβήτησης της νομιμότητας ή της νομιμότητας της εν λόγω δημοσίευσης ή του εν λόγω σχολίου. Μόνο εάν το περιεχόμενο κριθεί κατάλληλο από τη διαχείριση του "Κοινωνικού Δικτύου" θα παραμείνει ορατό.\n\nΜόλις το Περιεχόμενο μεταφορτωθεί στο "Κοινωνικό Δίκτυο", η Prozis διατηρεί το δικαίωμα να μεταφορτώσει ή να αναδημοσιεύσει το Περιεχόμενο Χρήστη απευθείας στις ψηφιακές της πλατφόρμες για την προώθηση της μάρκας της.',
    WITHOUT_POSTS: 'Δεν υπάρχουν ακόμη δημοσιεύσεις.',
    WITHOUT_POSTS_STATISTICS:
      'Δεν υπάρχουν δημοσιεύσεις μεταξύ των επιλεγμένων ημερομηνιών.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Ο σύνδεσμος αντιγράφηκε επιτυχώς στο πρόχειρο!',
    CREATED_SUCCESSFULLY: 'Δημιουργήθηκε με επιτυχία!',
    ERROR_PUBLISHING_INSAGRAM: 'Η ανάρτηση δημοσιεύθηκε στο instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'Η ανάρτηση δημοσιεύθηκε με επιτυχία στο Instagram.',
    POST_CREATED_SUCCESSFULLY: 'Δημιουργήθηκε με επιτυχία!',
    POST_SAVED_SUCCESSFULLY: 'Επιτυχής ενημέρωση!',
    POST_SUCCESSFULLY_DELETED: 'Επιτυχώς εξαλείφθηκε.',
    SAVED_SUCCESSFULLY: 'Επιτυχής ενημέρωση!',
    SUCCESSFULLY_DELETED: 'Διαγράφηκε επιτυχώς.',
    SUCCESSFULLY_REPLIED: 'Απαντήθηκε επιτυχώς.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS:
      'Παρακαλούμε αποδεχτείτε τους όρους και τις προϋποθέσεις!',
    EMPTY_PROFILE_IMAGE: 'Πρέπει να ανεβάσετε μια φωτογραφία προφίλ!',
    INVALID_FORM: 'Μη έγκυρη φόρμα!'
  }
};
